(function() {
    'use strict';
    
a3_pilot_reports.filter('paxNames', paxNames);
    /**
    * @memberof PilotReports
    * @ngdoc filter
    * @name paxNames
    * @description 
    *  List pax names in list and return $sce html 
    * @ngInject
    */  
function paxNames($sce) {
    return function(input) {
       var html =   '"<div class=\'row\'><div class=\'col-sm-offset-6 col-sm-2\'><strong>C</strong></div><div class=\' col-sm-1\'><strong>Y</strong></div> </div>';
       
        html = html + "<div class=\'row\'> <strong class=\'col-xs-6\'> Passengers </strong>"
                            html = html + '<div class=\'col-xs-2\'>' + input.PassengerSummaryC.Passengers + "</div>";
                            html = html + '<div class=\'col-xs-1\'>' + input.PassengerSummaryY.Passengers + '</div></div>';

        html = html + "<div class=\'row\'> <strong class=\'col-xs-6\'> PRM </strong>"
                    html = html + '<div class=\'col-xs-2\'>' + input.PassengerSummaryC.PRM + "</div>";
                    html = html + '<div class=\'col-xs-1\'>' + input.PassengerSummaryY.PRM + '</div></div>';

        html = html + "<div class=\'row\'> <strong class=\'col-xs-6\'> UMNR </strong>"
                    html = html + '<div class=\'col-xs-2\'>' + input.PassengerSummaryC.UMNR + "</div>";
                    html = html + '<div class=\'col-xs-1\'>' + input.PassengerSummaryY.UMNR + '</div></div>';

        html = html + "<div class=\'row\'> <strong class=\'col-xs-6\'> DEP </strong>"
                    html = html + '<div class=\'col-xs-2\'>' + input.PassengerSummaryC.DEP + "</div>";
                    html = html + '<div class=\'col-xs-1\'>' + input.PassengerSummaryY.DEP + '</div></div>\"';
        
       
       return $sce.trustAsHtml(html);
   }
};

})();